import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import Header from '../components/header'
import './bootstrap-grid-min.css';
import './swiper.min.css';
import './index.css';

const Layout = ({ children, data }) => (
  <div>
    <Helmet
      title={data.site.siteMetadata.title}
      meta={[
        { name: 'description', content: 'Benvenuto nel sito ufficiale di Birra Napoli. Entra e scopri tutto sulla birra esageratamente partenopea, proprio come te.' },
        { name: 'keywords', content: 'Birra napoli' },
      ]}
    />
    <Helmet>
      <meta property="fb:app_id" content="228688481161812" />
      <meta property="og:url" content="static/fb.png" />
        <meta property="og:type" content="article" />
          <meta property="og:title" content="Birra Napoli | Sito Ufficiale" />
            <meta property="og:description" content="Benvenuto nel sito ufficiale di Birra Napoli. Entra e scopri tutto sulla birra esageratamente partenopea, proprio come te." />
              <meta property="og:image" content="static/fb.png" />
                <meta property="og:image:width" content="1200" />
                  <meta property="og:image:height" content="630" />
      <link href="static/favicon.ico" rel="shortcut icon" />
        <link href="static/favicon.png" />

      <script>
        {`
        var _iub = _iub || [];
        _iub.csConfiguration = {
        cookiePolicyId: 58400707,
        siteId: 1439318,
        lang: "it"
      };
        (function (w, d) {
        var loader = function () { var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src = "//cdn.iubenda.com/cookie_solution/iubenda_cs.js"; tag.parentNode.insertBefore(s, tag); };
        if (w.addEventListener) { w.addEventListener("load", loader, false); } else if (w.attachEvent) { w.attachEvent("onload", loader); } else { w.onload = loader; }
      })(window, document);`
        }
      </script>

      <script>
        {`
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            '//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-xxxx');

        `}
      </script>

      <script>
        {`

        (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
                (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
            m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
        })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

        ga('create', 'UA-xxxxx-1', 'auto');
        ga('send', 'pageview');


        `}
      </script>

    </Helmet>
    <Header siteTitle={data.site.siteMetadata.title} />
    <div>
      {children()}
    </div>
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/layouts/index.js